exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newMsg[data-v-661e8431]{min-height:calc(100vh - 60px)}.msgContent[data-v-661e8431]{width:45%}.myInput[data-v-661e8431]{width:45%;display:inline-block;margin-right:10px}.campsBox[data-v-661e8431]{width:70%;height:200px;overflow-y:scroll;border:1px solid #e3e3e3;margin-top:20px;padding:10px}.s_item[data-v-661e8431]{display:inline-block;padding:8px 5px 8px 20px;border:1px solid #e3e3e3;box-sizing:border-box;font-size:12px;border-radius:5px;margin-right:10px;margin-top:10px;cursor:pointer}.closeIcon[data-v-661e8431]{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-661e8431&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/secretary/message/newMsg.vue
// module id = 560
// module chunks = 0